export default "__VITE_ASSET__b79fc812__"